import axios from "axios";

export const fetchMachineLabels = async (companyCode) => {
    const response = await axios.get(`api/machineLabel/?companyCode=${companyCode}`);
    const machineLabels = response.data;
    return machineLabels;
}

export const fetchMachineLabel = async (id) => {
    const response = await axios.get(`api/machineLabel/${id}/`);
    const machineLabel = response.data;
    return machineLabel;
}

export const createMachineLabel = async (machineLabel) => {
    const response = await axios.post("api/machineLabel/", machineLabel);
    const newMachineLabel = response.data;
    return newMachineLabel;
}

export const updateMachineLabel = async (machineLabel) => {
    const response = await axios.put(`api/machineLabel/`, machineLabel);
    const updatedMachineLabel = response.data;
    return updatedMachineLabel;
}

export const deleteMachineLabel = async (id) => {
    const response = await axios.delete(`api/machineLabel/${id}/`);
    const deletedMachineLabel = response.data;
    return deletedMachineLabel;
}